import {formatPageContentsMessages} from "../chrome/chromeUtils.ts";
import {formatFilesMessage} from "../ide/fileHandlerUtils.ts";

export const handleGiveResources = async (data: any, environmentObjRef: any, userObjRef: any, currentMessageRef: any, settingsObjRef: any, llmRequestRefs: any, processSubmitHelper: any) => {
    try {
        if (environmentObjRef.current.environment.includes("jetbrains") || environmentObjRef.current.environment === "vscode") {
            const openFileContents = JSON.parse(data[0]);
            const focusedFileContents = JSON.parse(data[1]);

            let fileErrors = "";
            try {
                fileErrors = JSON.parse(data[2]);
            } catch (error) {
                console.error("Error parsing file errors:", error);
            }
            try {
                llmRequestRefs.current.topLevelFiles = JSON.parse(data[3]);
            } catch (error) {
                console.error("Error parsing topLevelFiles:", error);
            }

            const filesMessages = formatFilesMessage(openFileContents, focusedFileContents, currentMessageRef, fileErrors, llmRequestRefs);

            if (llmRequestRefs.current.userMessage) {
                if (filesMessages.original && filesMessages.truncated) {
                    llmRequestRefs.current.userMessage.message.promptPrefix += filesMessages.original;
                    llmRequestRefs.current.userMessage.message.truncatedPromptPrefix = filesMessages.truncated;
                }

                llmRequestRefs.current.userMessage.message.promptPostfix += "\nDo not output line numbers when you output code.";
                // Basically try identifying Gemini and just steering it to not be dumb
                if (settingsObjRef.current.model.includes("Gemini") || (settingsObjRef.current.model === "Automatic" && userObjRef.current.subscriptionPlan === null)) {
                    llmRequestRefs.current.userMessage.message.promptPostfix += "\nKeep your answer short. When you output code, only rewrite exact the lines that need to be rewritten. If parts of a file will remain unchanged, do not output them in your response.";
                }
                if (settingsObjRef.current.mode !== "chat") {
                    llmRequestRefs.current.userMessage.message.promptPostfix += "\nWhen you create or edit a file and there are errors, be sure you address them if the errors are not expected.\nDo not implement changes that the user did not ask for. Stick to the scope of your assigned task.";
                }
                if (settingsObjRef.current.enableCodebaseSearch) {
                    llmRequestRefs.current.userMessage.message.promptPostfix += "\nDo not search around unless it is obvious you need to. If it seems like the context you have is sufficient, assume it actually is sufficient.";
                }
                llmRequestRefs.current.userMessage.message.truncatedPromptPostfix = '';
            }
            processSubmitHelper();
        } else if (environmentObjRef.current.environment === "chrome") {
            const url = data.url;
            const screenshot = data.screenshotUrl;
            const pageText = data.pageText ?? "";

            if (url) {
                if (llmRequestRefs.current.userMessage) {
                    const pageContentsMessages = await formatPageContentsMessages(url, pageText, screenshot, currentMessageRef, llmRequestRefs, settingsObjRef.current.contextMode, settingsObjRef.current.isIncognito, userObjRef.current.user);

                    llmRequestRefs.current.userMessage.message.promptPrefix += '\n' + pageContentsMessages.original;
                    llmRequestRefs.current.userMessage.message.truncatedPromptPrefix += '\n' + pageContentsMessages.truncated;
                }
            }
            processSubmitHelper();
        }
    } catch (error) {
        console.error("Error in handleGiveResources:", error);
    }
};
